import { Component, Input } from '@angular/core';
import { ControlBase } from '@components/dynamic-form/control-base';
import { FormGroup } from '@angular/forms';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { InputFieldComponent } from '@components/dynamic-form/input-field.component';

@Component({
  selector: 'app-telephone',
  templateUrl: './telephone.component.html',
  styleUrls: ['./telephone.component.scss'],
})
export class TelephoneComponent extends InputFieldComponent {
  @Input() meta!: ControlBase;
  @Input() form!: FormGroup;
  faIcon = faPhone;
}
